module.exports = __webpack_public_path__ + "img/MY_CART.d758451e.png";